import React from 'react';
import { connect } from 'react-redux';
import { actions } from '../redux/trackingLinkActions';
import TrackingLinkForm from '../components/TrackingLinkForm/TrackingLinkForm';
import InternalContainer from '../../layout/containers/Internal';
import '../../brokerApplication/containers/BrokerApplicationForm.scss';

/***********************************
 Container for the New Tracking Link Form
 ************************************/

const DEFAULT_TRACKING = {
  data: {
    type: 'broker',
    attributes: {
      branch_name: '',
      broker_type: 'tracking',
      organisation: {
        data: {},
      },
      metadata: {
        renewals_enabled: true,
        sales_banner_enabled: false,
      },
    },
  },
};

const TrackingLinkNewContainer = ({ onCreateTrackingLinkBroker }) => {
  const save = (resource) => {
    return onCreateTrackingLinkBroker(resource);
  };

  return (
    <InternalContainer title="New Tracking Link">
      <TrackingLinkForm resource={DEFAULT_TRACKING} onSave={save} />
    </InternalContainer>
  );
};

export default connect(
  null,
  {
    onCreateTrackingLinkBroker: actions.createTrackingLinkBroker,
  },
)(TrackingLinkNewContainer);
